import { render } from "./revenue_by_dates.vue?vue&type=template&id=6834bcc2&scoped=true"
import script from "./revenue_by_dates.vue?vue&type=script&lang=js"
export * from "./revenue_by_dates.vue?vue&type=script&lang=js"

import "./revenue_by_dates.vue?vue&type=style&index=0&id=6834bcc2&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6834bcc2"]])

export default __exports__